<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-hover">
      <thead>
        <tr>
          <th class="text-lefth">Producto</th>
          <th class="text-lefth">Tienda</th>
          <th class="text-center">Fecha inicio</th>
          <th class="text-center">Fecha fin</th>
          <th class="text-right">cantidad inicial</th>
          <th class="text-right">cantidad disponible</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="
            irAEsconderModal('inventario-liquidacion-producto-editar', {
              id: current.id,
            })
          "
        >
          <td>
            <div class="value">{{ current.producto_obj.sku }}</div>
            <small class="sub-value">{{ current.producto_obj.nombre }}</small>
          </td>
          <td>{{ current.tienda_obj.nombre }}</td>
          <td class="text-center">
            {{ current.fecha_inicio | moment("DD/MM/YYYY") }}
          </td>
          <td class="text-center">
            {{ current.fecha_fin | moment("DD/MM/YYYY") }}
          </td>
          <td class="text-right">
            {{ current.inicial }}
          </td>
          <td class="text-right">
            {{ current.disponible }}
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import OrdenCompraService from "@/services/compras/OrdenCompraService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() {},
  methods: {
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
